import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { CellTitle, CellCheckboxGroup } from '@root/components/Cell';
import Button from '@root/components/Button';
import './index.less';
import useUpdateDevice from '@root/hooks/subscription/useUpdateDevice';
import PageLoading from '@root/components/PageLoading';
import PageLoadError from '@root/components/PageLoadError';
import Empty from '@root/components/Empty';
import SafeAreaInset from '@root/components/SafeAreaInset';

const UpdatePackageDevice = () => {
  const { t } = useTranslation();
  const {
    detail,
    selected,
    loading,
    requesting,
    onSelected,
    onUpdatePackage,
    getDetail,
    onCloseWebview,
  } = useUpdateDevice();

  const { maxDevNum, devList, goodsPrice, isSelected } = detail;

  const options = useMemo(() => {
    if (!devList) {
      return [];
    }

    return devList.map((i) => ({
      title: i.deviceName,
      value: i.deviceId,
    }));
  }, [devList]);

  if (loading === 0) {
    return <PageLoading />;
  }

  if (loading === 2) {
    return <PageLoadError onTryAgain={getDetail} />;
  }

  if (isSelected || !options.length) {
    return (
      <div>
        <Empty marginTop={20}>
          {isSelected ? t('Message_expired') : t('no_data')}
          <div className="empty-container-btn">
            <Button onClick={onCloseWebview}>{t('ok')}</Button>
          </div>
        </Empty>
      </div>
    );
  }

  return (
    <>
      <div className="flex-section-auto adjust-device-card">
        <CellTitle>{t('change_package_update_device')}</CellTitle>

        <CellCheckboxGroup
          options={options}
          values={selected}
          onChange={onSelected}
          maxLength={maxDevNum}
          marginTop={0}
          marginBottom={0}
        />
      </div>
      <div className="flex-section-footer">
        <div className="footer-tips">
          <p
            className={`footer-label ${
              selected.length > maxDevNum ? 'error' : ''
            }`}
          >
            {t('device_management')}
            {maxDevNum > 1
              ? t('device_management_max', { maxDevNum })
              : t('device_management_max_one', { maxDevNum })}
          </p>
          <span className="total">
            {t('total')}: ${goodsPrice}
            {` / ${t('month')}`}
          </span>

          <span className="float-right">{`${maxDevNum} ${
            maxDevNum > 1 ? t('devices') : t('device')
          }`}</span>
        </div>
        <Button
          disabled={selected.length > maxDevNum}
          loading={requesting}
          onClick={onUpdatePackage}
        >
          {t('Downgrade')}
        </Button>
        <SafeAreaInset />
      </div>
    </>
  );
};

export default UpdatePackageDevice;
